import { render } from "./HealthView.vue?vue&type=template&id=89d3212c&scoped=true"
import script from "./HealthView.vue?vue&type=script&lang=js"
export * from "./HealthView.vue?vue&type=script&lang=js"

import "./HealthView.vue?vue&type=style&index=0&id=89d3212c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d3212c"]])

export default __exports__